import React from 'react'
import { Container } from './components/container';
import { Footer } from './components/footer';
import { Intro } from './intro';
import { Money } from './money';
import { Built } from './built';
import { Values } from './values';
import { Seeking } from './seeking';
import { ContestAward } from './contestaward';
import './investors.css'
import { Status } from '../docs/status';

export class Investors extends React.Component {
    render() {
        return (
            <>
            <div className='investors'>
                <Intro/>
                <Container>
                    <ContestAward />
                </Container>
                <Container>
                    <Money/>
                </Container>
                <Container>
                    <Built/>
                </Container>
                <Container>
                    <Status/>
                </Container>
                 <Container>
                    <Values/>
                </Container>
                <Container id="needed">
                    <Seeking/>
                </Container>
                <Footer/>
           </div>
           </>
        )
    }
}